<div class="form-row" [ngClass]="{ inline: inline }">
  <alert
    #deleteAlert
    (confirm)="handleDelete()"
    titleTrnKey="ARE_YOU_SURE"
    textTrnKey="YOU_WONT_BE_ABLE_TO_REVERT_THIS"
  />
  <button
    *ngIf="canDelete"
    type="button"
    class="form-row-delete"
    (click)="deleteAlert.fire()"
  >
    <i class="fas fa-trash"></i>
  </button>
  <div class="form-row-content">
    <ng-content></ng-content>
  </div>
</div>
